//
// ===== File globals.ts    
//
'use strict';

export const apiUrl='http://laso.local/server/api';



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/globals.ts